import axios from 'axios';
import { createNamespacedHelpers } from "vuex";

const state = {
  all: [],
  isLoading: false
}

const getters = {
  options(state) {
    return state.all.map(pc => ({ value: pc.id, text: pc.name }));
  }
}

const mutations = {
  startLoading(state) {
    state.isLoading = true;
  },
  loadAllSuccess(state, payrollCategories) {
    state.all = payrollCategories;
    state.isLoading = false;
  }
}

const actions = {
  async loadAll({ commit }) {
    commit('startLoading');

    let response = await axios.get('/api/payroll-categories');

    commit('loadAllSuccess', response.data.data);
  }
}

export const {
  mapState: mapPayrollCategoriesState,
  mapGetters: mapPayrollCategoriesGetters,
  mapMutations: mapPayrollCategoriesMutations,
  mapActions: mapPayrollCategoriesActions,
} = createNamespacedHelpers('payrollCategories');

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
